import {z} from 'zod'

import {validateName, validatePhoneNumber} from '../common/validation/validateContact'

import {OrderPlacerForm} from './types'

export const validateOrderPlacer = (data: OrderPlacerForm, ctx: z.RefinementCtx) => {
  const {orderPlacer} = data
  if (!orderPlacer) {
    // If orderPlacer is missing entirely, add validation error
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['orderPlacer'],
      message: 'Order placer information is required'
    })
    return
  }
  validatePhoneNumber(ctx, 'orderPlacer', orderPlacer.phoneNumber)
  validateName(ctx, 'orderPlacer', orderPlacer.name)
}
